import { Redirect, useLocation } from 'quartz-routing/react-router';
import { Flow } from 'signup-constants/Flow';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultSignupRedirect = props => {
  const {
    hash,
    search
  } = useLocation();
  return /*#__PURE__*/_jsx(Redirect, Object.assign({}, props, {
    to: {
      pathname: `/${Flow.Crm}`,
      search,
      hash
    }
  }));
};
export default DefaultSignupRedirect;